<!--
无内容

使用说明：

<Nothing
 />

-->

<template>
    <div class="nothing-wrap">
        <!--无内容-->
    </div>
</template>

<script>
export default {
  props: []
};
</script>

<style lang="less" scoped>
.nothing-wrap {
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/components/common/Nothing.vue